 const fields = [
  "LOI Date",
  "Tenant Entity Name",
  "Tenant Trade Name",
  "Tenant Owner Name",
  "Landlord Name",
  "Project Name",
  "Premises Street Address",
  "Premises Suite",
  "Premises City",
  "Premises State",
  "Term",
  "Renewal Options",
  "Rent Commencement Date",
  "Lease Commencement Date",
  "NNN Estimate (psf)",
  "CAM (psf)",
  "Controlled CAM (psf)",
  "Uncontrolled CAM (psf)",
  "RET (psf)",
  "INS (psf)",
  "Delivery Date",
  "Rent Abatement",
  "Percentage Rent",
  "Document Name",
  "Guarantor Name",
  "Guarantor Entity Name",
  "LL Work (entire  section)"
];

export default fields;